import React from "react";
import "./index.css";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { initAuthInterceptor } from "./utils/apiConfig";

initAuthInterceptor();

const container = document.getElementById("root");
if (container) {
  const root = createRoot(container);
  root.render(<App />);
}
